import { Transactions } from "types/Models/books";

export type VendorGroup = {
  vendorName: string;
  vendorKey: string;
  merchantUuid: string | null;
  logo: string | undefined;
  transactions: Transactions[];
  totalAmount: number;
};

export function groupTransactionsByVendor(rows: Transactions[]): VendorGroup[] {
  const groupMap = new Map<string, VendorGroup>();

  for (const txn of rows) {
    const merchant = txn.transaction.merchant;
    const key = merchant || "__unknown__";

    if (!groupMap.has(key)) {
      groupMap.set(key, {
        vendorName: merchant || "Unknown Vendors",
        vendorKey: key,
        merchantUuid: txn.transaction.merchant_uuid || null,
        logo: txn.transaction.logo,
        transactions: [],
        totalAmount: 0,
      });
    }

    const group = groupMap.get(key)!;
    group.transactions.push(txn);
    group.totalAmount += Number(txn.transaction.amount || 0);
  }

  const named: VendorGroup[] = [];
  let unknown: VendorGroup | undefined;

  for (const group of groupMap.values()) {
    if (group.vendorKey === "__unknown__") {
      unknown = group;
    } else {
      named.push(group);
    }
  }

  if (unknown) {
    return [...named, unknown];
  }

  return named;
}
